export namespace Configuration {
  export const SystemUserId: string = "00000000-0000-0000-0000-000000000000";
}
